<div *ngFor="let header of tabHeaders; index as i;" class="tab-container">
  <div (click)="onTabClick(i)" [class.tab-selected]="tabHeaders[tabIndex] === tabHeaders[i]"
       class="tab-selector"
       id="tabs-admin"
       pRipple>
      <div class="icon">
        <i *ngIf="tabHeadersIcons[i]" [className]="tabHeadersIcons[i]"></i>
      </div>
      <div class="tab-name">{{header}}</div>
  </div>
</div>
<div id="tabs-footer"></div>
